import { SSRBase as o } from "@phosphor-icons/react/ssr";
export * from "@phosphor-icons/react/ssr";
o.defaultProps = {
  weight: "bold"
};
